import { Grid } from "@mui/material";
import { StyledNuevaObra } from "../../../styled/Obras";

const TitleWithUnderline = ({ title }) => {
    return (
        <Grid item xs={12}>
            <StyledNuevaObra.GrupoTitulo variant="h6">
                {title}
            </StyledNuevaObra.GrupoTitulo>
        </Grid>


    );
};

export default TitleWithUnderline;
